if (!customElements.get('collection-merchandiser')) {
  class CollectionMerchandiser extends HTMLElement {
    /**
     * A custom element that adds interactivity to the collection merchandiser section.
     * @details Interactivity includes image loading and default tab setting.
     * @details Component is dependent on the TabInterface component.
     * @class CollectionMerchandiser
     * @extends HTMLElement
     */
    constructor() {
      super();

      this.tabInterface = document.querySelector('tab-interface');
    }

    connectedCallback() {
      if (this.tabInterface) {
        this.hasProductViewTracking = this.hasAttribute('data-product-view-tracking');
        this.defaultProduct = sessionStorage.getItem('product-view');

        this.tabInterface.addEventListener('tabChange', this.tabChangeListener.bind(this));
      }
    }

    /**
     * Handles the tab change event.
     * @param event
     */
    tabChangeListener(event) {
      this.onTabChange(event);

      requestAnimationFrame(() => {
        if (this.hasProductViewTracking && this.defaultProduct !== null) {
          this.setDefaultTab(this.defaultProduct);
        }
      });
    }

    /**
     * Handles the tab change event.
     * @param {Event} event - The tab change event.
     * @returns {void}
     */
    onTabChange(event) {
      const { tabpanel } = event.detail;
      const images = tabpanel.querySelectorAll('img[data-src]');

      if (typeof imageLazyLoader === "function") {
        imageLazyLoader(images);
      } else {
        console.error('⚠️ Global Image lazy loader function not found.');
        images.forEach((image) => {
          if (image.classList.contains('lazy-loading')) {
            const img = new Image();
            img.srcset = image.dataset.srcset;
            img.onload = () => {
              image.srcset = image.dataset.srcset;
              image.src = image.dataset.src;
              image.removeAttribute('data-src');
              image.removeAttribute('data-srcset');
              image.classList.remove('lazy-loading');
            };
          }
        });
      }
    }

    /**
     * Sets the default tab. After checking if product tracking is enabled and the user has viewed a product
     * @param {string} productId - The product ID.
     * @returns {void}
     */
    setDefaultTab(productId) {
      if (this.defaultProduct !== null && this.hasProductViewTracking) {
        const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        const matchedTab = tabs.find((tabs) => {
          return tabs.dataset.products.includes(productId);
        });

        if (matchedTab && this.tabInterface && typeof this.tabInterface.setSelectedTab == 'function') {
          this.defaultProduct = null;
          sessionStorage.removeItem('product-view');
          this.tabInterface.setSelectedTab(matchedTab);
        }
      }
    }
  }

  customElements.define('collection-merchandiser', CollectionMerchandiser);
}
